<template>
	<div class="main">
		<Header ref="header"></Header>
		<div class="home-banners" :style="{backgroundImage: `url('${bgLink}')`}">
			<div class="banner-placeholder"></div>
			<div class="banner-wrapper">
				<el-carousel :interval="5000" arrow="always" @change="bannerChange">
					<el-carousel-item v-for="(item, index) in swiper" :key="index">
						<div class="banner-item" @click="openUrl(item.url)">
							<p class="banner-title">{{ item.name }}</p>
							<p class="banner-subtitle">{{ item.info }}</p>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		
		<div class="home-main" :style="{backgroundImage: `url('${bgMain}')`}">
		    <div class="home-main-wrapper">
				<div class="home-feature">
					<div class="feature-item animated fadeInLeft" @click="$router.replace('/gov')">
						<div>
							<img class="feature-icon" src="../assets/img/home/icon-1-1.png" alt=""/>
						</div>
						<div class="feature-title">
							<p class="title--main">政务中心</p>
							<div class="divider-line"></div>
							<div style="height: 14px"></div>
							<p class="feature-desc">政务指南 惠企直达</p>
						</div>
					</div>
					<div class="feature-item animated fadeInDown" @click="$router.replace('/product')">
						<div>
							<img class="feature-icon" src="../assets/img/home/icon-1-2.png" alt=""/>
						</div>
						<div class="feature-title">
							<p class="title--main">商务中心</p>
							<div class="divider-line"></div>
							<div style="height: 14px"></div>
							<p class="feature-desc">产业协同 供需对接</p>
						</div>
					</div>
					<div class="feature-item animated fadeInRight" @click="$router.replace('/news')">
						<div>
							<img class="feature-icon" src="../assets/img/home/icon-1-3.png" alt=""/>
						</div>
						<div class="feature-title">
							<p class="title--main">资讯中心</p>
							<div class="divider-line"></div>
							<div style="height: 14px"></div>
							<p class="feature-desc">行业资讯 时政要闻</p>
						</div>
					</div>
				</div>
				
				<div class="home-theme">
					<div class="theme-title">
						<p class="theme-title--main">主题</p>
						<p class="theme-title--sub">THE ME</p>
						<div class="divide-line"></div>
					</div>
					<div class="theme-wrapper">
						<el-row :gutter="20">
							<el-col :span="6" class="wow animated fadeInUp">
								<img src="../assets/img/home/icon-4.fw.png" alt="" @click="issue"/>
							</el-col>
							<el-col :span="18">
								<el-row :gutter="20">
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-4.png" alt="" @click="openUrl('http://i-ddk.com/about/1.html')"/>
									</el-col>
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-5.png" alt="" @click="openUrl('./xm')"/>
									</el-col>
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-6.png" alt="" @click="openUrl('./yl')"/>
									</el-col>
								</el-row>
								<el-row :gutter="20" style="margin-top: 15px;">
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-9.png" alt="" @click="openUrl('./news?c=企业法律风险防范')"/>
									</el-col>
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-11.png" alt=""  @click="openUrl('https://dadukou.xycq.gov.cn/')"/>
									</el-col>
									<el-col :span="8" class="wow animated fadeInUp">
										<img src="../assets/img/home/icon-10.png" alt=""  @click="openUrl('http://zl.i-ddk.com/')"/>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<!-- <div  class="theme-item" @click="openUrl('http://i-ddk.com/about/a1.html')">
							<img src="../assets/img/home/icon-4.png" alt="" />
						</div>
						<div  class="theme-item" @click="openUrl('./govDetail?id=244')">
							<img src="../assets/img/home/icon-5.png" alt="" />
						</div>
						<div  class="theme-item" @click="openUrl('./govDetail?id=245')">
							<img src="../assets/img/home/icon-6.png" alt="" />
						</div>
						<div  class="theme-item" @click="openUrl('https://dadukou.xycq.gov.cn/')">
							<img src="../assets/img/home/icon-11.png" alt="" />
						</div> -->
				  </div>
				</div>
				
				<div class="home-about" style="padding: 100px 0px;">
				  <div class="about-left">
				    <div class="about-title">
				      <p class="about-title--main">关于大渡口</p>
				      <p class="about-title--sub">About Dadukou</p>
				      <div class="divide-line"></div>
				    </div>
				    <p class="about-desc wow animated fadeInUp">
				      大渡口区地处重庆市主城区西南部，濒临长江，东临巴南，南接江津，西、北面与九龙坡接壤，全域位于两山（中梁山、铜锣山）两江（长江、嘉陵江）之间、外环高速以内。全区幅员面积103平方公里，现辖五街三镇，常住人口42万。据史料记载，在清朝道光年间，长江北岸设有义渡，该渡口为沿江数十里渡口之首，大渡口由此得名。1938年，重钢前身汉阳铁厂由汉迁渝落户大渡口1965年，大渡口因服务重钢正式设区；1995年，大渡口进行区划调整，辖区面积进一步扩大，2011年，重钢在区生产主线完成环保搬迁，大渡口进入转型发展崭新时期；
				    </p>
				    <div class="check-more" @click="openUrl('http://www.ddk.gov.cn/mlddk/ddkgk_364558/ddkgl/202211/t20221102_11253911.html')"></div>
				  </div>
				  <div class="about-right wow animated fadeInUp">
				    <img class="img" src="@/assets/img/home/icon-12.png" alt="" />
				  </div>
				</div>
				
				<div class="home-contact">
				  <div class="contact-title">
				    <p class="contact-title--main">联系我们</p>
				    <p class="contact-title--sub">ABOUT US</p>
				    <div class="divide-line"></div>
				  </div>
				  <div class="contact-cont">
				    <div class="contact-cont--left">
				      <div class="address common wow animated fadeInUp">
				        <p>地址：</p>
				        <p>重庆市大渡口区海康路106号1号楼</p>
				      </div>
				      <div class="contact-phone common wow animated fadeInUp" style="margin-left: 150px;">
				        <p>电话：</p>
				        <p>023-68537611</p>
				      </div>
				      <div class="email common wow animated fadeInUp">
				        <p>邮箱：</p>
				        <p>i-ddk@foxmail.com</p>
				      </div>
				    </div>
				    <div class="contact-cont--right wow animated fadeInUp" style="margin-top: -25px;">
				      <!-- <img class="qrcode" src="@/assets/img/weixin.png" alt="" />  -->
				      <img class="qrcode" src="@/assets/img/erweima.webp" alt="" />
				      <p class="qr-desc">关注公众号</p>
				    </div>
				  </div>
				</div>
		    </div>
		</div>
		<Footer/>
	</div>
</template>
<script>
	import Header from '../components/Header.vue'
	import Footer from '../components/footer.vue'
	import {Api} from "../utils/axios.js"
	export default {
		data(){
			return{
				/* swiper:[{info: '',name: '中国共产党第二十大全国代表大会',url: 'http://cpc.people.com.cn/20th/'}], */
				swiper:[],
				active: 0
			}
		},
		components: {
			Header,Footer
		},
		computed: {
			bgLink() {
				//return this.active === 0 ? require('@/assets/img/zq_bg.webp') : require('@/assets/img/banner.webp')
				return require('@/assets/img/banner.webp')
			},
			bgMain() {
				return require('@/assets/img/home-bg.webp')
			}
		},
		methods: {
			loadData(){
				Api('data/initSwiper',{}).then((res) => {
					if(res.code==200){
						res.result.swiper.forEach(v => {
							this.swiper.push(v)
						})
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			bannerChange(index) {
				this.active = index
			},
			openUrl(url) {
				window.open(decodeURIComponent(url))
			},
			issue(){
				if(sessionStorage.getItem('uid')==null){
					this.$parent.showLogin()
					return
				}
				let routeData = this.$router.resolve({ path: './issue'});
				window.open(routeData.href, '_blank');
			},
		},
		created:function(){
			this.loadData();
		},
		mounted() {
		    this.$nextTick(()=>{
				this.$wow.init()
			})
		},
	}
</script>
<style scoped>
	.main{margin-top: -75px;}
	.home-banners {
		height: 572px;
		background-size: 100% 100%;
		transition: .3s;
	}
	.banner-placeholder {
	  height: 72px;
	}
	.banner-wrapper {
	  height: calc(100% - 72px);
	  width: 1300px;
	  margin: auto;
	}
	.banner-item {
	  height: 100%;
	  color: #fff;
	  cursor: pointer;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: center;
	}
	.banner-item .banner-title{
		padding: 5px 0;
		font-size: 50px;
		font-weight: 600;
		margin: 0px !important;
	}
	.banner-item .banner-subtitle{padding: 5px 0;
	    font-size: 36px;
	    font-weight: 400;
		margin: 0px;
	}
	
	.home-main {
		background-size: 100% 91%;
		background-position: center 90%;
		background-repeat: no-repeat;
	}
	.home-main-wrapper{
		width: 1300px;
		margin: auto;
	}
	
	.home-feature {
	  padding: 48px 0;
	  display: flex;
	  justify-content: space-between;
	}
	.feature-item {
	  display: flex;
	  width: 373px;
	  padding: 50px 26px;
	  border-radius: 15px;
	  transition: 0.3s;
	  cursor: pointer;
	  justify-content: center;
	}
	.feature-item:hover{
		color: #1e9fff;
		background-color: #fff;
	}
	.feature-title {
	    margin-left: 25px;
	 }
	.title--main{
		color: #101010;
		font-size: 33px;
		margin: 0px;
		text-align: left;
		text-shadow: 0 0 5px rgb(0 0 0 / 30%);
	}
	.title--sub {
		color: #b1b1b1;
		font-size: 14px;
		margin:0px
	}
	  .divider-line {
	    width: 130px;
	    height: 2px;
	    background: #4a73ff;
	    margin-top: 16px;
	  }
	  .feature-desc {
	    font-size: 16px;
	    color: #666666;
	    font-family: PingFang;
		margin: 0px;
		text-align: left;
	  }
	  .feature-icon{
	    width: 90px;
	    height: 90px;
		margin-left: -10px;
	  }
	  .home-theme {
	    padding: 25px 0;
	  }
	  .theme-title--main{
		  font-size: 40px;
		  font-family: PingFang;
		  font-weight: 800;
		  color: #222222;
	  }
	  .theme-title--sub{
		  font-size: 20px;
		  font-family: PingFang;
		  font-weight: 500;
		  color: #b1b1b1;
	  }
		.divide-line {
		  margin-top: 15px;
		  width: 100px;
		  height: 2px;
		  background: #4a73ff;
	  }
	  .theme-wrapper {
	    margin-top: 30px;
	    /*display: grid;
	    grid-template-columns: repeat(4, 1fr);
	    gap: 20px;*/
	  }
	  .theme-wrapper img{max-width: 100%;cursor: pointer;}
	  .theme-item {
	    width: 310px;
	    height: 140px;
	    cursor: pointer;
	  }
	  .theme-item img{width: 100%;}
	  
	  
	  .home-about .about-title{
		  margin-top: 10px;
	  }
	  .home-about .about-title .about-title--main{
		  font-size: 40px;
		  font-family: PingFang;
		  font-weight: 800;
		  color: #222222;
	  }
	  .home-about .about-title .about-title--sub{
	  		font-size: 20px;
	  		font-family: PingFang;
	  		font-weight: 500;
	  		color: #b1b1b1;
	  		text-transform: uppercase;
	  }
	  .home-about .about-title .divide-line{
		  margin-top: 15px;
		  width: 100px;
		  height: 2px;
		  background-color: #4a73ff;
	  }
	  .home-about {
	    padding: 50px 0;
	    display: flex;
	}
	.about-desc {
	  margin-top: 20px;
	  margin-bottom: 30px;
	  line-height: 30px;
	  font-size: 16px;
	  font-family: PingFang SC;
	  font-weight: 400;
	  color: #666666;
	}
	.check-more {
	  width: 120px;
	  height: 34px;
	  cursor: pointer;
	  background-image: url('../assets/img/home/icon-13.png');
	}
	.about-right {
	  flex-shrink: 0;
	  width: 620px;
	  height: 416px;
	}
	.img {
	  width: 100%;
	  height: 100%;
	}
	
	.home-contact {
	  padding: 25px 0;
	}
	.contact-title--main {
	    font-size: 40px;
	    font-family: PingFang;
	    font-weight: 800;
	    color: #222222;
	  }
	.contact-title--sub {
	    font-size: 20px;
	    font-family: PingFang;
	    font-weight: 500;
	    color: #b1b1b1;
	  }
	.contact-title .divide-line {
	    margin-top: 15px;
	    width: 100px;
	    height: 2px;
	    background: #4a73ff;
	  }
	.contact-cont {
	  padding: 30px 0;
	  display: flex;
	  }
	.contact-cont--left {
	    flex: 1;
	    display: flex;
	}
	.contact-cont .common {
	      flex: 1;
	      font-size: 20px;
	      font-family: PingFang SC;
	      font-weight: 400;
	      color: #666666;
	}
	.contact-cont p {
	      line-height: 30px;
	}
	.contact-cont--right {
	    display: flex;
	    align-items: center;
	}
	.contact-cont--right .qrcode {
	      width: 110px;
	      height: 110px;
	}
	.contact-cont--right .qr-desc {
	      font-size: 16px;
	      font-family: PingFang SC;
	      font-weight: 400;
	      color: #666666;
	      writing-mode: vertical-rl;
	      text-orientation: upright;
	}
</style>
<style>
	.el-carousel{height: 100% !important;}
	.el-carousel__container{height: 100% !important;}
	.el-carousel__arrow{background-color: transparent !important;font-size: 36px !important;}
	.el-carousel__button {width: 10px !important;height: 10px !important; border-radius: 50% !important;}
	.theme-wrapper img{box-shadow: rgb(0 0 0 / 30%) 0px 2px 12px 0px;}
</style>